<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="25.732"
    height="26.414"
    viewBox="0 0 25.732 26.414"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.616"
        y1="-0.199"
        x2="0.4"
        y2="1.765"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#ff4b58" />
        <stop offset="1" stop-color="#cb0000" />
      </linearGradient>
    </defs>
    <g
      id="Сгруппировать_3089"
      data-name="Сгруппировать 3089"
      transform="translate(0 0)"
    >
      <path
        id="Контур_3580"
        data-name="Контур 3580"
        d="M328.584,73.016a8.347,8.347,0,0,1-1.845,4.527,10.962,10.962,0,0,1-5.861,4.058,6.178,6.178,0,0,1-3.808-6.508,6.451,6.451,0,0,1,1.753-3.423c.634-.7,1.309-1.367,1.934-2.076a3.909,3.909,0,0,0,1.133-3.5c-.116-.568.167-.742.72-.522a5.446,5.446,0,0,1,3.02,5.47c-.035.19-.222.436.016.537.312.133.445-.174.542-.4a6.322,6.322,0,0,0,.248-.8c.045-.165,0-.395.224-.439s.294.163.4.3A28.185,28.185,0,0,1,328.584,73.016Z"
        transform="translate(-312.331 -60.115)"
        fill="#fac300"
        stroke="#db7b0e"
        stroke-width="1"
      />
      <g id="Сгруппировать_3088" data-name="Сгруппировать 3088">
        <path
          id="Контур_3576"
          data-name="Контур 3576"
          d="M-772.852-1382.442a14.338,14.338,0,0,0-.306-3.414l-.086-.514-.074.013c-.051.008-.1.017-.144.026a2.1,2.1,0,0,1-.252.038.341.341,0,0,0-.269.109.392.392,0,0,0-.037.314c.093.481.16.97.224,1.443a7.4,7.4,0,0,1-.138,3.272,1.486,1.486,0,0,1-.668.887,3.39,3.39,0,0,1-.925.382,8.646,8.646,0,0,1-.91.144c-.178.022-.355.044-.531.072l-.236.033a1.778,1.778,0,0,0-1.349.608.236.236,0,0,1-.118.026,3.8,3.8,0,0,0-2.424,1.141,10.105,10.105,0,0,0-2.072,2.9c-.512,1.025-1.009,2.079-1.49,3.1-.291.616-.582,1.232-.879,1.85a8.964,8.964,0,0,1-1.379,2.26,15.425,15.425,0,0,1-2.651,2.289,8.955,8.955,0,0,1-6.813,1.6,10.925,10.925,0,0,0-1.408-.167.757.757,0,0,0-.6.221.734.734,0,0,0-.167.6,2.392,2.392,0,0,0,.329.962,3.734,3.734,0,0,0,1.917,1.438,12.273,12.273,0,0,0,4.512.849,13.819,13.819,0,0,0,2.807-.3,12.357,12.357,0,0,0,2.9-.99c.207-.1.425-.19.636-.275.238-.1.484-.2.718-.315a27.646,27.646,0,0,0,6.469-4.61,20.424,20.424,0,0,0,4.134-5.307,6.777,6.777,0,0,0,.751-4.38,2.758,2.758,0,0,0-.27-.728c-.053-.11-.105-.22-.15-.331-.018-.044-.039-.089-.06-.133a.776.776,0,0,1-.1-.294,6.451,6.451,0,0,1,.518-2.316A9.314,9.314,0,0,0-772.852-1382.442Zm-1.919,4.171a1.5,1.5,0,0,0-.026.172c-.053.528-.053.528-.562.586a1.923,1.923,0,0,1-1.641-.567c-.15-.148-.3-.305-.451-.471l-.144-.155a10.159,10.159,0,0,1,1.117-.173,5.971,5.971,0,0,0,1.922-.447Zm-.813,1.581c.1.005.2.011.3.019a.351.351,0,0,0,.107-.013l.042-.008c.67-.09.836.035.924.7a6.32,6.32,0,0,1-.366,3.213,10.362,10.362,0,0,1-1.2,2.211,22.779,22.779,0,0,1-3.021,3.446,27.207,27.207,0,0,1-7.509,5.093,13.847,13.847,0,0,1-2.675.908,11.562,11.562,0,0,1-7.252-.593,2.83,2.83,0,0,1-1.262-.974,2.012,2.012,0,0,1-.185-.378c-.017-.043-.035-.087-.056-.134l.1.007c.115.008.205.014.291.028a13.8,13.8,0,0,0,3.009.267,10.167,10.167,0,0,0,4.96-1.693,16.259,16.259,0,0,0,3.008-2.506,9.769,9.769,0,0,0,1.612-2.587q.487-1,.963-2.01c.488-1.026.993-2.086,1.509-3.118a8.635,8.635,0,0,1,1.721-2.392,3.2,3.2,0,0,1,1.746-.94.894.894,0,0,1,.918.328,2.672,2.672,0,0,0,1.567,1.046A5.362,5.362,0,0,0-775.584-1376.69Z"
          transform="translate(798.566 1386.37)"
          fill="#af0e0e"
        />
        <path
          id="Контур_3577"
          data-name="Контур 3577"
          d="M-773.781-1370.349c-.1-.744-.343-.932-1.092-.832a.56.56,0,0,0-.056.011.293.293,0,0,1-.062.009c-.1-.008-.2-.013-.3-.019a5.3,5.3,0,0,1-.731-.074,2.493,2.493,0,0,1-1.479-.993,1.042,1.042,0,0,0-1.058-.382,3.339,3.339,0,0,0-1.826.98,8.809,8.809,0,0,0-1.751,2.432c-.517,1.034-1.022,2.095-1.51,3.121-.32.67-.639,1.341-.963,2.008a9.648,9.648,0,0,1-1.586,2.55,16.087,16.087,0,0,1-2.98,2.483,10.01,10.01,0,0,1-4.888,1.669,13.4,13.4,0,0,1-2.976-.265c-.093-.016-.187-.022-.306-.03-.063,0-.135-.008-.218-.016l-.128-.011.053.116c.04.087.073.168.1.244a2.112,2.112,0,0,0,.2.406,2.981,2.981,0,0,0,1.327,1.026,11.271,11.271,0,0,0,4.5.926,12.949,12.949,0,0,0,2.839-.324,14.044,14.044,0,0,0,2.7-.917,27.388,27.388,0,0,0,7.551-5.12,22.971,22.971,0,0,0,3.04-3.469,10.493,10.493,0,0,0,1.218-2.243A6.468,6.468,0,0,0-773.781-1370.349Z"
          transform="translate(798.217 1380.861)"
          fill="url(#linear-gradient)"
        />
        <path
          id="Контур_3578"
          data-name="Контур 3578"
          d="M-760.608-1374.985a5.436,5.436,0,0,1-2.009.5,9.135,9.135,0,0,0-1.261.207l-.122.032.087.092c.081.086.158.168.232.247.156.168.3.325.455.475a2.049,2.049,0,0,0,1.485.625,2.419,2.419,0,0,0,.278-.016c.6-.069.633-.1.695-.725a1.469,1.469,0,0,1,.023-.153l.278-1.36Z"
          transform="translate(784.687 1381.829)"
          fill="#94000f"
        />
        <path
          id="Контур_3579"
          data-name="Контур 3579"
          d="M-767.921-1370.6c-.008-.02-.017-.041-.034-.078,0,0-.033-.181-.084-.2-.023-.006-.076.059-.076.059a10.8,10.8,0,0,0-2.725,3.6c-.162.293-.324.585-.493.876l-.04.069.759.381.035-.063c.082-.148.161-.293.239-.435.174-.319.339-.62.515-.919l.036-.061a11.475,11.475,0,0,1,1.681-2.372l.026-.026C-767.753-1370.1-767.745-1370.139-767.921-1370.6Z"
          transform="translate(787.648 1380.15)"
          fill="#af0e0e"
        />
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconHot',
  }
</script>
